export {};
// import * as React from 'react';
// import {Base_ResolutionFunctionEditorPanel} from '../Base_ResolutionFunctionEditorPanel.js';
// import {UI_Expression} from '@app/hcs-frontend';
// import {
// 	Component_ExpressionPrettyPrinter
// } from '@app/hcs-frontend';
// import './Panel_PrettyPrint.scss';
//
// type Props = {
// 	uiExpression: UI_Expression
// 	hidePanel: VoidFunction
// }
//
// type State = {
// 	expression: UI_Expression
// }
//
// export class Panel_PrettyPrint
// 	extends Base_ResolutionFunctionEditorPanel<Props, State> {
//
// 	protected panelId: string = 'pretty-print';
//
// 	protected deriveStateFromProps(nextProps: Props, state: State): State {
// 		state.expression = nextProps.uiExpression;
// 		return state;
// 	}
//
// 	protected renderHeader = () => {
// 		return <>
// 			Pretty print resolution function
// 		</>;
// 	};
//
// 	protected renderBody = () => {
// 		return <Component_ExpressionPrettyPrinter
// 			expressionToPrint={this.state.expression}
// 			showHeader
// 		/>;
// 	};
// }
//# sourceMappingURL=Panel_PrettyPrint.js.map